'use client'

import { displayPriceWithCurrency, storage, useCurrency } from '@repo/ui'
import { useEffect, useState } from 'react'

const CurrencyAwarePrice = ({ minPrice, maxPrice, suffix = '', fallback }) => {
  const { currency, isHydrated, ratesLoaded } = useCurrency()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch by only showing dynamic prices after mount
  useEffect(() => {
    setMounted(true)
  }, [])

  // Show fallback only on server-side or before mount to prevent hydration mismatch
  if (!mounted) {
    return fallback
  }

  // Round to integers
  const roundedMin = minPrice ? Math.round(minPrice) : null
  const roundedMax = maxPrice ? Math.round(maxPrice) : null

  // Use current currency immediately after mount to avoid lag
  const activeCurrency = currency

  // If currency is USD, no conversion needed
  if (activeCurrency === 'USD') {
    if (roundedMin && roundedMax) {
      return `${displayPriceWithCurrency(roundedMin, 'USD')}–${displayPriceWithCurrency(roundedMax, 'USD')}${suffix}`
    } else if (roundedMin) {
      return `${displayPriceWithCurrency(roundedMin, 'USD')}${suffix}`
    }
    return fallback
  }

  // For non-USD currencies, check if exchange rates are available
  if (typeof window !== 'undefined') {
    const rates = storage.getRates()
    if (!rates || !rates[activeCurrency]) {
      // If rates not loaded yet, show fallback to avoid displaying misleading prices
      // (e.g., showing E£50 when it should be E£1,550 after conversion)
      if (!ratesLoaded) {
        return fallback
      }
      // If rates loaded but currency not available, show fallback
      console.warn(
        `Exchange rates not available for ${activeCurrency}, showing fallback`,
      )
      return fallback
    }
  }

  // Safe to convert
  if (roundedMin && roundedMax) {
    return `${displayPriceWithCurrency(roundedMin, activeCurrency)}–${displayPriceWithCurrency(roundedMax, activeCurrency)}${suffix}`
  } else if (roundedMin) {
    return `${displayPriceWithCurrency(roundedMin, activeCurrency)}${suffix}`
  } else {
    return fallback
  }
}

export default CurrencyAwarePrice
